import BooleanField from "./BooleanField";

interface ComplexBooleanFieldProps {
  label: string;
  isPositive?: boolean;
  yesText?: string;
  noText?: string;
  InjectCicleEmojiIfPositive?: boolean;
  InjectCicleEmojiIfNegative?: boolean;
  InjectCicleEmoji?: boolean;
  hintText?: string;
}

function ComplexBooleanField({
  label,
  isPositive = true,
  yesText = "Есть",
  noText = "Отсутствует",
  InjectCicleEmojiIfPositive = true,
  InjectCicleEmojiIfNegative = false,
  InjectCicleEmoji = true,
  hintText = "",
}: ComplexBooleanFieldProps) {
  return (
    <BooleanField
      label={label}
      value={isPositive}
      yesText={yesText}
      noText={noText}
      className={
        isPositive
          ? ""
          : `rounded-md text-white pr-4 ${label === "Юрисдикция" ? "bg-red" : "bg-light-yellow"}`
      }
      InjectCicleEmojiIfPositive={InjectCicleEmojiIfPositive}
      InjectCicleEmojiIfNegative={InjectCicleEmojiIfNegative}
      InjectCicleEmoji={InjectCicleEmoji}
      hintText={isPositive ? "" : hintText}
      tooltipClassName={
        isPositive
          ? "absolute top-[0.3125rem] right-[0.3125rem]"
          : "absolute top-[0.3125rem] right-[0.3125rem] text-red"
      }
      iconClassName={
        isPositive
          ? "bg-gray-2 text-main"
          : `bg-white ${label === "Юрисдикция" ? "text-red" : "text-light-yellow"}`
      }
    />
  );
}

export default ComplexBooleanField;
